export const getTipoAtividades = (state) => state.tipoAtividades.lista
export const getIsCarregandoListaTipoAtividades = (state) => state.tipoAtividades.isCarregandoLista
export const getIsSavingTipoAtividades = (state) => state.tipoAtividades.isSaving
export const getIsUpdatingTipoAtividades = (state) => state.tipoAtividades.isUpdate
